import config from '../config'
export default {
  computed: {
    hasDropdownLoaded () {
      return this.$store.state.commonObj.hasDropdownLoaded
    }
  },
  watch: {
    hasDropdownLoaded: function () {
      this.loadDropdownCommonConfig()
    }
  },
  created () {
    this.loadDropdownCommonConfig()
  },
  methods: {
    loadDropdownCommonConfig () {
      config.getData('/common')
      .then(response => {
          if (response.status_code === 200) {
            this.$store.commit('mutateCommonProperties', {
              divisionList: response.divisionList,
              districtList: response.districtList,
              thanaList: response.thanaList,
              districtThanaList: response.districtThanaList,
              merchantList: response.merchantList,
              coverageAreaList: response.coverageAreaList,
              areaList: response.areaList,
              // merchantAreaList: response.merchantAreaList,
              storeList: response.storeList,
              bankList: response.bankList,
              hubList: response.hubList,
              logisticPartnerList: response.logisticPartnerList,
              riderList: response.riderList,
              reasonList: response.reasonList,
              weightChargeList: response.weightChargeList,
              userList: response.userList,
              issueList: response.issueList,
              roleList: response.roleList,
              wrongStatusList: response.wrongStatusList,
              zonalList: response.zonalList
            })
          }
          this.$store.dispatch('commonObjLoad', false)
      })
    }
  }
}